import { render } from "./productKardex.vue?vue&type=template&id=198e38fc&scoped=true"
import script from "./productKardex.vue?vue&type=script&lang=js"
export * from "./productKardex.vue?vue&type=script&lang=js"

import "./productKardex.vue?vue&type=style&index=0&id=198e38fc&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198e38fc"]])

export default __exports__